import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1.5">
            {comic.isFree && (
              <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                免费
              </span>
            )}
            {comic.isHot && (
              <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                热门
              </span>
            )}
            {comic.isNew && (
              <span className="px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                新作
              </span>
            )}
          </div>
        </div>
        {comic.status === '已完结' && (
          <div className="absolute top-3 right-3">
            <span className="px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 text-xs whitespace-nowrap">
              {comic.status}
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 mb-1.5 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="whitespace-nowrap">{comic.author}</span>
          <div className="flex items-center gap-0.5">
            <i className="ri-eye-line text-xs"></i>
            <span>{formatViews(comic.views)}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-xs text-accent-500"></i>
            <span className="text-xs text-accent-600 font-medium">{comic.rating}</span>
          </div>
          <span className="text-xs px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 whitespace-nowrap">
            {comic.category}
          </span>
        </div>
      </div>
    </Link>
  );
}